import React from 'react';

const Pagination = ({ 
  currentPage, 
  hasMore, 
  onPrevious, 
  onNext, 
  loading = false 
}) => {
  return (
    <div className="flex justify-center mt-8">
      <div className="bg-white rounded-lg shadow-sm border border-gray-400 px-4 py-2 flex items-center justify-center space-x-6">
        {/* Previous Button */}
        <button
          onClick={onPrevious}
          disabled={currentPage === 0 || loading}
          className="flex items-center space-x-1 text-gray-600 hover:text-[#6e28cc] disabled:opacity-40 disabled:cursor-not-allowed transition-colors duration-200"
        >
          {loading ? (
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-[#6e28cc]"></div>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          )}
          <span className="text-sm font-medium">Previous</span>
        </button>

        {/* Page Count in Center */}
        <div className="text-sm text-gray-500">
          <span className="font-semibold text-[#6e28cc]">{currentPage + 1}</span>
        </div>

        {/* Next Button */}
        <button
          onClick={onNext}
          disabled={!hasMore || loading}
          className="flex items-center space-x-1 text-gray-600 hover:text-[#6e28cc] disabled:opacity-40 disabled:cursor-not-allowed transition-colors duration-200"
        >
          <span className="text-sm font-medium">Next</span>
          {loading ? (
            <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-300 border-t-[#6e28cc]"></div>
          ) : (
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default Pagination;
